import React from "react";

const Banner = () => {
  return (
    <div className="mx-4 p-10 text-white rounded-2xl bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500">
      <div className="flex items-center mb-4">
        <img
          className="w-16 mr-3"
          src="/tool/dashboard/static/images/star.svg"
          alt="Star"
        />
        <div>
          <h1 className="text-3xl font-bold mb-2">Welcome to vidBoard AI</h1>
          <p className="text-lg font-medium leading-8">
            Produce high-caliber videos utilizing pre-designed templates for a
            polished and professional outcome.
          </p>
        </div>
      </div>
      <div className="relative mt-4">
        {/* <input 
          type="text" 
          className="w-full p-3 rounded-2xl bg-white text-black placeholder-gray-600 focus:ring-2 focus:ring-purple-600 focus:outline-none" 
          placeholder="Type any topic to create content with vidBoard AI" 
        /> */}
        <img
          className="absolute top-1/2 right-4 transform -translate-y-1/2 w-8"
          src="/tool/dashboard/static/images/star.svg"
          alt="Search"
        />
      </div>
    </div>
  );
};
export default Banner;
